import { Component, OnInit, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import '../../../../assets/semantic/semantic.min.js';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DemandService } from '../../../_services/demand.service';

@Component({
  selector: 'app-delete-demand',
  templateUrl: './delete-demand.component.html',
  styleUrls: ['./delete-demand.component.css']
})
export class DeleteDemandComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  private to_delete;

  constructor(private service: DemandService) { }

  ngOnInit() {
  }
  
  openModal(demand_id){
    this.to_delete = demand_id;
    jQuery('#delete-demand-modal').modal({closable: false}).modal('show');
  }

  deleteDemand(){
    if(!this.to_delete) { // Return false if the ID of the contact is not stored
      jQuery('#delete-demand-modal').modal('hide');
      return false;
    } 
    let demand_id = this.to_delete // Store it in a var
    this.to_delete = undefined; // Invalidate the contact to delete (avoid spamming during the deletion process)
    jQuery('#delete-demand-modal').modal({closable: false}); // Set the modal unclosable during the deletion process
    this.service.deleteDemand(demand_id) // Delete the Contact
      .subscribe(response => {
        jQuery('#delete-demand-modal').modal('hide');
        this.refresh.emit(true); // Close the modal
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/demand/delete-demand/delete-demand.component.ts